<template>
  <td class="pr-4">
    <h6 class="custom-margin-h6-table">
      <strong>{{ $t('sigatoka.bw_config') }}:</strong>
    </h6>

    <div class="d-flex flex-direction-row">
      <span v-for="(value, index) in leafs" :key="index" class="mb-2 px-2">
        <div
          class="shadow-sm d-flex p-2 px-3"
          style="
            height: auto;
            color: black;
            width: auto;
            border: 1px solid #67c23a;
          "
          type="info"
        >
          <div class="pt-2">
            <div class="d-flex justify-content-between">
              <h6 class="mb-2">
                <strong>{{ $t('sigatoka.leaf') }} </strong>
              </h6>
              {{ value.number }}
            </div>
            <div class="d-flex justify-content-between">
              <h6 class="mb-1">
                <strong>{{ $t('sigatoka.stages') }}:</strong>
              </h6>
              <span>
                {{ value.status.filter((v) => v !== null).join(', ') }}
              </span>
            </div>
            <h6 class="mb-1 mt-2">
              <strong>{{ $t('sigatoka.gross_sum_values') }} (- / +):</strong>
            </h6>
            <div class="d-flex justify-content-around">
              <div v-for="(item, i) in value.plus" :key="i">
                {{ value.minus[i] || 0 }}/{{ item || 0 }}
              </div>
            </div>
          </div>
        </div>
      </span>
    </div>
  </td>
</template>
<script>
export default {
  name: 'info-bw',
  props: {
    leafs: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
